export const normalizeDataByField = (dataArray, field) => {
  let byId = {};
  let allIds = [];

  for (let i = 0; i < dataArray.length; i++) {
    let c = dataArray[i];
    byId[c[field]] = { ...c }; // insert into byId object as { "[creative-id]": [creative] }
    allIds.push(c[field]); // add id to the list of ids
  }

  return { byId, allIds };
};
